var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 42,
    viewBox: "0 0 8 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 4C0.8 5.76731 2.23269 7.2 4 7.2C5.76731 7.2 7.2 5.76731 7.2 4C7.2 2.23269 5.76731 0.8 4 0.8C2.23269 0.8 0.8 2.23269 0.8 4ZM3.4 4V4.95H4.6V4H3.4ZM3.4 6.85V8.75H4.6V6.85H3.4ZM3.4 10.65V12.55H4.6V10.65H3.4ZM3.4 14.45V16.35H4.6V14.45H3.4ZM3.4 18.25V20.15H4.6V18.25H3.4ZM3.4 22.05V23.95H4.6V22.05H3.4ZM3.4 25.85V27.75H4.6V25.85H3.4ZM3.4 29.65V31.55H4.6V29.65H3.4ZM3.4 33.45V35.35H4.6V33.45H3.4ZM3.4 37.25V39.15H4.6V37.25H3.4ZM3.4 41.05V42H4.6V41.05H3.4Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.0084416afa0a09d3a68813cc2ae22c2a.svg";
export { ForwardRef as ReactComponent };